import { render } from "./VideoContent.vue?vue&type=template&id=0f33955e&ts=true"
import script from "./VideoContent.vue?vue&type=script&lang=ts"
export * from "./VideoContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__